var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { safeAssign } from "./safe-assign";
// Embedded DTOs for payroll data
/**
 * Information about an employee's children for PV bonus calculation
 * @description The amount to be paid depends on the number of children under the age of 25
 */
class PayrollChildInfoDTO {
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PayrollChildInfoDTO.prototype, "firstName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PayrollChildInfoDTO.prototype, "lastName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PayrollChildInfoDTO.prototype, "birthdate", void 0);
/**
 * Employment information for additional job tracking
 * @description Information about additional employment relationships for determining social insurance obligations
 */
class PayrollEmploymentInfoDTO {
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PayrollEmploymentInfoDTO.prototype, "nameEmployer", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PayrollEmploymentInfoDTO.prototype, "addressEmployer", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PayrollEmploymentInfoDTO.prototype, "startDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PayrollEmploymentInfoDTO.prototype, "endDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PayrollEmploymentInfoDTO.prototype, "workingDays", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PayrollEmploymentInfoDTO.prototype, "additionalMarginalJobStart", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], PayrollEmploymentInfoDTO.prototype, "additionalMarginalJobExemption", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], PayrollEmploymentInfoDTO.prototype, "requiresSocialSecurityContribution", void 0);
/**
 * Bank account information for salary payments
 * @description Employee's banking details for payroll transfers
 */
class BankDetailsDTO {
}
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], BankDetailsDTO.prototype, "payByBankTransfer", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], BankDetailsDTO.prototype, "bankAccountOwner", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], BankDetailsDTO.prototype, "iban", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], BankDetailsDTO.prototype, "bankName", void 0);
/**
 * Current employment and registration status
 * @description Employee's current status for social insurance categorization
 */
class CurrentStatusDTO {
}
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], CurrentStatusDTO.prototype, "immatriculationStatus", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CurrentStatusDTO.prototype, "currentStatus", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CurrentStatusDTO.prototype, "otherStatus", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], CurrentStatusDTO.prototype, "registeredAsJobSeeker", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CurrentStatusDTO.prototype, "responsibleAgency", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], CurrentStatusDTO.prototype, "receivingAgencyBenefits", void 0);
/**
 * Working student specific facts for insurance classification
 * @description Determines social insurance obligations for working students
 */
class WorkingStudentFactsDTO {
}
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], WorkingStudentFactsDTO.prototype, "lowSalary", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], WorkingStudentFactsDTO.prototype, "shortTermEmployment", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], WorkingStudentFactsDTO.prototype, "moreThan20hOutsideSemesterBreak", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], WorkingStudentFactsDTO.prototype, "vacationSemester", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], WorkingStudentFactsDTO.prototype, "semesterAbove25", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], WorkingStudentFactsDTO.prototype, "moreThan182DaysOver20h", void 0);
/**
 * Professional status indicators for short-term employment classification
 * @description Berufsmäßigkeit - determines if short-term employment counts as professional work
 */
class ShortTermEmploymentProfessionalismDTO {
}
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "registeredAsJobSeekerShortTerm", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "receivingAgencyBenefits", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "receivingSocialBenefits", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "parentalLeave", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "militaryOrVoluntaryService", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "federalVoluntaryService", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "startingApprenticeship", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "startingPublicService", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "employmentBetweenTrainingAndStudy", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "employmentBetweenStudyAndWork", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "employmentDuringService", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "recentFixedTermContract", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "sameEmployerBefore", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "newEmploymentAfterPrevious", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "leaveFromMainJob", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "eveningSchoolStudent", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalismDTO.prototype, "seasonalHarvestWork", void 0);
/**
 * Information about additional employment relationships
 * @description Tracks all additional jobs to ensure compliance with social insurance limits
 */
class AdditionalEmploymentDTO {
}
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], AdditionalEmploymentDTO.prototype, "additionalRegularEmployment", void 0);
__decorate([
    Expose(),
    Type(() => PayrollEmploymentInfoDTO),
    __metadata("design:type", Array)
], AdditionalEmploymentDTO.prototype, "additionalRegularEmploymentInfo", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], AdditionalEmploymentDTO.prototype, "additionalWorkingStudentEmployment", void 0);
__decorate([
    Expose(),
    Type(() => PayrollEmploymentInfoDTO),
    __metadata("design:type", Array)
], AdditionalEmploymentDTO.prototype, "additionalWorkingStudentEmploymentInfo", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], AdditionalEmploymentDTO.prototype, "additionalMarginalEmployment", void 0);
__decorate([
    Expose(),
    Type(() => PayrollEmploymentInfoDTO),
    __metadata("design:type", Array)
], AdditionalEmploymentDTO.prototype, "additionalMarginalEmploymentInfo", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AdditionalEmploymentDTO.prototype, "additionalMarginalEmploymentSalary", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], AdditionalEmploymentDTO.prototype, "additionalShortTermEmployment", void 0);
__decorate([
    Expose(),
    Type(() => PayrollEmploymentInfoDTO),
    __metadata("design:type", Array)
], AdditionalEmploymentDTO.prototype, "additionalShortTermEmploymentInfo", void 0);
/**
 * Educational background information
 * @description Employee's educational qualifications for statistical reporting
 */
export class EducationDTO {
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], EducationDTO.prototype, "schoolEducation", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EducationDTO.prototype, "professionalEducation", void 0);
/**
 * Health insurance information
 * @description Employee's health insurance status for payroll deductions
 */
class HealthInsuranceStatusDTO {
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], HealthInsuranceStatusDTO.prototype, "ensuranceType", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], HealthInsuranceStatusDTO.prototype, "otherEnsuranceType", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], HealthInsuranceStatusDTO.prototype, "lastEnsurance", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], HealthInsuranceStatusDTO.prototype, "ensurerName", void 0);
/**
 * Disability information
 * @description Voluntary disability status for employer statistics
 */
class DisabilityInfoDTO {
}
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], DisabilityInfoDTO.prototype, "disabilityLevel", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DisabilityInfoDTO.prototype, "disabilityLevelPercentage", void 0);
/**
 * Complete payroll data for an employee
 * @description Comprehensive payroll information including employment, tax, insurance, and personal details
 */
export class EmployeePayrollDataDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], EmployeePayrollDataDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeePayrollDataDTO.prototype, "occupation", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeePayrollDataDTO.prototype, "passportNumber", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], EmployeePayrollDataDTO.prototype, "mainJob", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeePayrollDataDTO.prototype, "pvBonusChildren", void 0);
__decorate([
    Expose(),
    Type(() => PayrollChildInfoDTO),
    __metadata("design:type", Array)
], EmployeePayrollDataDTO.prototype, "pvChildInfo", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeePayrollDataDTO.prototype, "taxClass", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeePayrollDataDTO.prototype, "taxClass4Factor", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeePayrollDataDTO.prototype, "childrenFreeAmount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeePayrollDataDTO.prototype, "confession", void 0);
__decorate([
    Expose(),
    Type(() => BankDetailsDTO),
    __metadata("design:type", BankDetailsDTO)
], EmployeePayrollDataDTO.prototype, "bankDetails", void 0);
__decorate([
    Expose(),
    Type(() => CurrentStatusDTO),
    __metadata("design:type", CurrentStatusDTO)
], EmployeePayrollDataDTO.prototype, "currentStatus", void 0);
__decorate([
    Expose(),
    Type(() => WorkingStudentFactsDTO),
    __metadata("design:type", WorkingStudentFactsDTO)
], EmployeePayrollDataDTO.prototype, "workingStudentFacts", void 0);
__decorate([
    Expose(),
    Type(() => ShortTermEmploymentProfessionalismDTO),
    __metadata("design:type", ShortTermEmploymentProfessionalismDTO)
], EmployeePayrollDataDTO.prototype, "shortTermEmploymentProfessionalism", void 0);
__decorate([
    Expose(),
    Type(() => AdditionalEmploymentDTO),
    __metadata("design:type", AdditionalEmploymentDTO)
], EmployeePayrollDataDTO.prototype, "additionalEmployment", void 0);
__decorate([
    Expose(),
    Type(() => EducationDTO),
    __metadata("design:type", EducationDTO)
], EmployeePayrollDataDTO.prototype, "education", void 0);
__decorate([
    Expose(),
    Type(() => HealthInsuranceStatusDTO),
    __metadata("design:type", HealthInsuranceStatusDTO)
], EmployeePayrollDataDTO.prototype, "healthInsuranceStatus", void 0);
__decorate([
    Expose(),
    Type(() => DisabilityInfoDTO),
    __metadata("design:type", DisabilityInfoDTO)
], EmployeePayrollDataDTO.prototype, "disabilityInfo", void 0);
export class GetEmployeePayrollDataParams {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], GetEmployeePayrollDataParams.prototype, "employeeId", void 0);
/**
 * Parameters for updating employee payroll data
 * @description Used to update or create payroll information for an employee
 * All fields are optional except employeeId which is required
 */
export class UpdateEmployeePayrollDataParams {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], UpdateEmployeePayrollDataParams.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], UpdateEmployeePayrollDataParams.prototype, "occupation", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], UpdateEmployeePayrollDataParams.prototype, "passportNumber", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], UpdateEmployeePayrollDataParams.prototype, "mainJob", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], UpdateEmployeePayrollDataParams.prototype, "pvBonusChildren", void 0);
__decorate([
    Expose(),
    Type(() => PayrollChildInfoDTO),
    __metadata("design:type", Array)
], UpdateEmployeePayrollDataParams.prototype, "pvChildInfo", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], UpdateEmployeePayrollDataParams.prototype, "taxClass", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], UpdateEmployeePayrollDataParams.prototype, "taxClass4Factor", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], UpdateEmployeePayrollDataParams.prototype, "childrenFreeAmount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], UpdateEmployeePayrollDataParams.prototype, "confession", void 0);
__decorate([
    Expose(),
    Type(() => BankDetailsDTO),
    __metadata("design:type", BankDetailsDTO)
], UpdateEmployeePayrollDataParams.prototype, "bankDetails", void 0);
__decorate([
    Expose(),
    Type(() => CurrentStatusDTO),
    __metadata("design:type", CurrentStatusDTO)
], UpdateEmployeePayrollDataParams.prototype, "currentStatus", void 0);
__decorate([
    Expose(),
    Type(() => WorkingStudentFactsDTO),
    __metadata("design:type", WorkingStudentFactsDTO)
], UpdateEmployeePayrollDataParams.prototype, "workingStudentFacts", void 0);
__decorate([
    Expose(),
    Type(() => ShortTermEmploymentProfessionalismDTO),
    __metadata("design:type", ShortTermEmploymentProfessionalismDTO)
], UpdateEmployeePayrollDataParams.prototype, "shortTermEmploymentProfessionalism", void 0);
__decorate([
    Expose(),
    Type(() => AdditionalEmploymentDTO),
    __metadata("design:type", AdditionalEmploymentDTO)
], UpdateEmployeePayrollDataParams.prototype, "additionalEmployment", void 0);
__decorate([
    Expose(),
    Type(() => EducationDTO),
    __metadata("design:type", EducationDTO)
], UpdateEmployeePayrollDataParams.prototype, "education", void 0);
__decorate([
    Expose(),
    Type(() => HealthInsuranceStatusDTO),
    __metadata("design:type", HealthInsuranceStatusDTO)
], UpdateEmployeePayrollDataParams.prototype, "healthInsuranceStatus", void 0);
__decorate([
    Expose(),
    Type(() => DisabilityInfoDTO),
    __metadata("design:type", DisabilityInfoDTO)
], UpdateEmployeePayrollDataParams.prototype, "disabilityInfo", void 0);
export function createEmployeePayrollData(values) {
    const defaults = {
        // Main job status - entity default is false
        mainJob: false,
        // Optional primitive fields
        occupation: undefined,
        passportNumber: undefined,
        pvBonusChildren: undefined,
        pvChildInfo: undefined,
        taxClass: undefined,
        taxClass4Factor: undefined,
        childrenFreeAmount: undefined,
        confession: undefined,
        // Bank details - matching entity defaults from entities.ts
        bankDetails: {
            payByBankTransfer: true, // Entity default from BankDetails
            bankAccountOwner: undefined,
            iban: undefined,
            bankName: undefined,
        },
        // Current status - matching entity defaults
        currentStatus: {
            immatriculationStatus: false,
            currentStatus: undefined,
            otherStatus: undefined,
            registeredAsJobSeeker: false,
            responsibleAgency: undefined,
            receivingAgencyBenefits: false,
        },
        // Working student facts - all booleans default to false in entity
        workingStudentFacts: {
            lowSalary: false,
            shortTermEmployment: false,
            moreThan20hOutsideSemesterBreak: false,
            vacationSemester: false,
            semesterAbove25: false,
            moreThan182DaysOver20h: false,
        },
        // Short-term employment professionalism - all booleans default to false in entity
        shortTermEmploymentProfessionalism: {
            registeredAsJobSeekerShortTerm: false,
            receivingAgencyBenefits: false,
            receivingSocialBenefits: false,
            parentalLeave: false,
            militaryOrVoluntaryService: false,
            federalVoluntaryService: false,
            startingApprenticeship: false,
            startingPublicService: false,
            employmentBetweenTrainingAndStudy: false,
            employmentBetweenStudyAndWork: false,
            employmentDuringService: false,
            recentFixedTermContract: false,
            sameEmployerBefore: false,
            newEmploymentAfterPrevious: false,
            leaveFromMainJob: false,
            eveningSchoolStudent: false,
            seasonalHarvestWork: false,
        },
        // Additional employment - all booleans default to false in entity
        additionalEmployment: {
            additionalRegularEmployment: false,
            additionalRegularEmploymentInfo: undefined,
            additionalWorkingStudentEmployment: false,
            additionalWorkingStudentEmploymentInfo: undefined,
            additionalMarginalEmployment: false,
            additionalMarginalEmploymentInfo: undefined,
            additionalMarginalEmploymentSalary: undefined,
            additionalShortTermEmployment: false,
            additionalShortTermEmploymentInfo: undefined,
        },
        // Education - no defaults in entity
        education: undefined,
        // Health insurance status - no defaults in entity
        healthInsuranceStatus: undefined,
        // Disability info - matching entity defaults
        disabilityInfo: {
            disabilityLevel: false,
            disabilityLevelPercentage: undefined,
        },
    };
    // Merge these groups onto their defaults because stored onboarding forms may only map some of their fields
    return new EmployeePayrollDataDTO({
        ...defaults,
        ...values,
        shortTermEmploymentProfessionalism: {
            ...defaults.shortTermEmploymentProfessionalism,
            ...values.shortTermEmploymentProfessionalism,
        },
        additionalEmployment: { ...defaults.additionalEmployment, ...values.additionalEmployment },
        disabilityInfo: { ...defaults.disabilityInfo, ...values.disabilityInfo },
    });
}
//# sourceMappingURL=employee-payroll-data.dto.js.map